import { GSForm, GSSidePanelPage, useFormDataValidation } from "golfstatus_react_components";
import { getSaveBannerActions, useNotificationBanner } from "../../../hooks/notificationHooks";
import { clearNotifications, getMobilePaySettings, selectCurrentMobilePaySettings, selectSettingsNotifications, setMobilePaySetting, updateMobilePaySettings } from "../../../reducers/settingsSlice";
import { useMatch, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { paymentSettingsMobileForm } from "../../../forms/SettingsForms";

//import scss
import "./tournament-settings-payments-mobile.scss";

const TournamentSettingsPaymentsMobile = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const match = useMatch("/:tournamentID/settings/payments/mobile");
    const notifications = useSelector(selectSettingsNotifications);

    const mobilePaySettings = useSelector(selectCurrentMobilePaySettings);

    const [context, isValid, setIsValid] = useFormDataValidation({
        initialValid: false,
        data: mobilePaySettings,
        setData: (update) => {
            dispatch(setMobilePaySetting(update));
        }
    });

    useEffect(() => {
        if (match?.params?.tournamentID) {
            dispatch(getMobilePaySettings(match.params.tournamentID));
        }

        return () => {
            dispatch(clearNotifications());
        }
    }, [dispatch, match?.params?.tournamentID]);

    const save = () => {
        setIsValid(false);
        let update = { ...mobilePaySettings };

        dispatch(updateMobilePaySettings(update));
    };

    const getDrawerActions = () => {
        let actions = [
            {
                name: "Save",
                isDisabled: !isValid,
                action: save,
                type: "black",
            },
            { name: "cancel", action: leftNavigation, type: "grey" },
        ];

        return actions;
    };

    const leftNavigation = () => {
        if (isValid && !banner) {
            setUnsaved(true);
            return;
        }
        timeoutAction();
        const { tournamentID } = match.params;
        navigate(`/${tournamentID}/settings/payments`, {replace: true});
    };

    const getNavigation = () => {
        return {
            title: 'In-App Payment Processing',
            leftIcon: faChevronLeft,
            leftButtonClick: leftNavigation,
        };
    };

    const getContent = () => {
        return (
            <GSForm
                formTitle="In-App Payment Processing"
                formSections={paymentSettingsMobileForm(context, mobilePaySettings)}
            ></GSForm>
        );
    };

    const timeoutAction = () => {
        dispatch(clearNotifications());
    };

    const getDrawer = () => {
        return {
            actions: getDrawerActions(),
        };
    };

    let notificationSettings = {
        notifications: notifications,
        saveAction: save,
        bannerActions: getSaveBannerActions(save, leftNavigation),
        timeoutAction,
    };

    const [banner, setUnsaved] = useNotificationBanner(notificationSettings);
    
    return (
        //name the component tag
        <tournament-settings-payments-mobile>
        <GSSidePanelPage
            header={getNavigation()}
            banner={banner}
            content={getContent()}
            drawer={getDrawer()}
        ></GSSidePanelPage>
        </tournament-settings-payments-mobile>
    );
};

export default TournamentSettingsPaymentsMobile;